import { render, staticRenderFns } from "./LaborProtectionChecklists.vue?vue&type=template&id=35878e8e&"
import script from "./LaborProtectionChecklists.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionChecklists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports